import React from 'react'
import { Collapse } from 'react-collapse'

import { compose, withHandlers, withState } from 'recompose'

import MinusIcon from 'assets/icons/minus.svg'
import PlusIcon from 'assets/icons/plus.svg'

import {
  AccordionHeader,
  AccordionHeaders,
  AccordionHeadersIcon,
  AccordionSubheader,
  AccordionTrigger,
  AccordionWrapper,
  CollapseContentContainer,
} from './styled-components'

type Props = {
  className?: string
  dataTestId?: string
  header: string
  subheader: string
  imagePath: string
  children: React.ReactNode
}

type StateProps = {
  isOpened: boolean
  setIsOpened: (open: boolean) => void
}

type HandlerProps = {
  handleClick: () => void
}

type EnhancedProps = Props & StateProps & HandlerProps

const enhance = compose<EnhancedProps, Props>(
  withState('isOpened', 'setIsOpened', false),
  withHandlers<StateProps, HandlerProps>({
    handleClick: ({ isOpened, setIsOpened }) => () => setIsOpened(!isOpened),
  }),
)

const Accordion: React.SFC<EnhancedProps> = ({
  className,
  dataTestId,
  header,
  subheader,
  children,
  handleClick,
  imagePath,
  isOpened,
}) => (
  <AccordionWrapper className={className} data-testid={dataTestId}>
    <AccordionTrigger onClick={handleClick}>
      <AccordionHeadersIcon src={imagePath} />
      <AccordionHeaders>
        <AccordionHeader>{header}</AccordionHeader>
        <AccordionSubheader>{subheader}</AccordionSubheader>
      </AccordionHeaders>
      <img src={isOpened ? MinusIcon : PlusIcon} alt={'expand and collapse'} />
    </AccordionTrigger>

    <Collapse isOpened={isOpened}>
      <CollapseContentContainer>{children}</CollapseContentContainer>
    </Collapse>
  </AccordionWrapper>
)

export default enhance(Accordion)
